import { styled } from 'stitches.config'
import Image from 'next/image'

export const Logo = styled(Image, {
  width: '183px',
  height: '42px',
  margin: 'auto',

  '@bp1': {
    width: '296px',
    height: '64px',
  },
})

export const MainNav = styled('nav', {
  '& ul': {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '$3',
    alignItems: 'center',
    borderBottom: '1px solid $accent-black',
    paddingBottom: '$4',
  },

  '@bp1': {
    '& ul': {
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      flexWrap: 'wrap',
      borderBottom: 'none',
      paddingBottom: '0',
    },
  },
})

export const SecondaryNav = styled('nav', {
  '& ul': {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '$3',
    alignItems: 'center',
    borderBottom: '1px solid $accent-black',
    paddingBottom: '$4',
  },

  '@bp1': {
    '& ul': {
      flexDirection: 'row',
      justifyContent: 'center',
      flexWrap: 'wrap',
      borderBottom: 'none',
      paddingBottom: '0',
    },
  },
})

export const SocialMediaNav = styled('nav', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  // '@bp1': {
  //   '& ul li:last-child': {
  //     display: 'none',
  //   },
  // },
})

export const ContactUsNav = styled('nav', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '@bp1': {
    '& ul li:last-child': {
      display: 'none',
    },
  },
})

export const FooterNavigation = styled('div', {
  py: '$5',
  px: '$3',
  width: '100%',

  '@bp1': {
    paddingTop: '$7',
    paddingBottom: '$5',
  },
})

export const PoliciesNav = styled('nav', {
  fontSize: '$small',
  fontWeight: '$regular',
  lineHeight: '$small',
  marginBottom: '$2',
  color: '$accent-black',
  fontFamily: '$body',
  order: 1,

  '& ul': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '$2',
    '& li': {
      flex: '0 1 auto',
    },
  },

  '@bp1': {
    '& ul': {
      padding: 0,
      flexDirection: 'row',
    },
  },
})

export const ContactUs = styled('div', {
  fontSize: '$small',
  fontWeight: '$bold',
  order: 2,
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: '$2',
})

export const Copyright = styled('div', {
  marginBottom: '$2',
  fontSize: '$small',
  fontWeight: '$bold',
  order: 0,
  display: 'flex',
  alignItems: 'flex-start',
})

export const OptOut = styled('div', {
  fontSize: '$small',
  fontWeight: '$bold',
  order: 2,
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: '$2',
})

export const FooterPolicies = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  flexDirection: 'column',
  paddingTop: '$3',
  paddingBottom: '$14',
  px: '$2',
  width: '100%',
  '& > *': {
    flex: '1 1 0px',
    justifyContent: 'center',
  },

  '@bp2': {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    paddingTop: 0,
    paddingBottom: '$4',
    px: '$5',
  },
})

export const FooterRoot = styled('footer', {
  color: '$accent-black',
  background: '$accent-white',
  fontFamily: '$body',
})

export const SocialMediaList = styled('ul', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '$5',

  '@media screen and (max-width: 440px)': {
    maxWidth: '60%',
  },

  '@bp1': {
    gap: '$6',
    maxWidth: '100%',
  },
})
